<div class="topup-info-dialog">
  <h3>{{ header }}</h3>
  <p>
    {{ description }}
  </p>
  <mat-dialog-actions align="start">
    <button mat-raised-button matDialogClose color="primary">Zamknij</button>
  </mat-dialog-actions>
</div>
